import { ColoredLogoWithName } from "@/components/svg";

export default function BirdFlyingLoader() {
  return (
    <div className="fixed inset-0 z-[50] flex items-center">
      <div className="flex flex-col items-center mx-auto text-white">
        <div className="flex flex-col  items-center w-[250px] h-[200px] overflow-hidden relative">
          <div className="w-[150px] overflow-hidden z-10">
            <ColoredLogoWithName
              id="loader-logo"
              className="bounce-bird w-[300%] mt-6"
            />
          </div>
          <div className="animate-wind absolute w-full h-[200px] flex flex-col gap-y-4">
            <div className="border-b border-disabled-purple w-12 h-4"></div>
            <div className="border-b border-disabled-purple w-12 h-4 translate-x-32"></div>
            <div className="border-b border-disabled-purple w-12 h-4 translate-x-96"></div>
            <div className="border-b border-disabled-purple w-12 h-4 translate-x-64"></div>
            {/* <div className="border-b border-disabled-purple w-12 h-4 translate-x-80"></div> */}
          </div>
        </div>
        <p className="text-black"></p>
      </div>
    </div>
  );
}
